var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "notification-popup-container",
      attrs: { "extension-name": "notification" }
    },
    [
      _c(
        "span",
        {
          staticClass: "notification-popup-close-button",
          on: {
            click: function($event) {
              return _vm.$emit("close", false)
            }
          }
        },
        [_vm._v("×")]
      ),
      _vm._v(" "),
      _c("b", { staticClass: "notification-popup-title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "notification-popup-message" }, [
        _vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b06d32c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b06d32c","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/NotificationPopup.vue
// module id = 454
// module chunks = 0